import React from 'react';
import propTypes from 'prop-types';
import HtmlContent from 'tailwind-components/HtmlContent/HtmlContent';
import MarkdownContent from 'tailwind-components/MarkdownContent/MarkdownContent';
import { cn } from 'lib/utils';

// any opening or closing tag (<i>, </p>, <br/>, <a href=...>) marks the text as html
const HTML_TAG_PATTERN = /<\/?[a-z][a-z0-9]*(\s[^>]*)?\/?>/i;

/**
 * renders authored rich text that may be either html (zoho rich text fields)
 * or markdown. html goes through the sanitized HtmlContent; anything else is
 * parsed as markdown. mixing both in one string is not supported: once a tag
 * is found, markdown syntax renders literally.
 * @param content - raw html or markdown string
 * @param className - extra classes for the wrapper
 * @param compact - tighter type and spacing, for table cells and cards
 */
export default function RichTextContent({
  content,
  className,
  compact = false
}) {
  if (!content) return null;

  if (HTML_TAG_PATTERN.test(content)) {
    return (
      <HtmlContent
        html={content}
        className={cn(compact && 'text-sm', className)}
      />
    );
  }
  return (
    <MarkdownContent
      markdown={content}
      className={className}
      compact={compact}
    />
  );
}

RichTextContent.propTypes = {
  content: propTypes.string,
  className: propTypes.string,
  compact: propTypes.bool
};
